const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the category editor component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('categoryEditor', ['Application', 'Categories', '$translate', function (Application, Categories, $translate) {
  return {
    restrict: 'E',
    scope: {
      type: '@',
      language: '=',
      refresh: '='
    },
    template: require('../../templates/directives/category-editor.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.languages = Application.languages.getAvailable();

      self.selectLanguage = function(item) {
        item.abr = item.abr.toLowerCase();
        $scope.language = item;
      };

      self.type = $scope.type;

      self.translatedata = {
        type: ($scope.type === 'org_level'? 'Level' : ($scope.type.charAt(0).toUpperCase() + $scope.type.slice(1)))
      };

      self.translationType = {
        type: ($scope.type === 'org_level'? 'Level' : ($scope.type.charAt(0).toUpperCase() + $scope.type.slice(1)))
      };

      self.sortCategories = function() {
        angular.forEach(self.categories, function(cat) {
          if (cat.level === 1) {
            self.topLevel.push(cat);
          }
          if (cat.level === 10) {
            self.main = cat;
            self.initialMainName = cat.name.slice(0);
          }

          self.directory[cat._id] = cat;
        });
      };

      self.addCategory = function(category) {
        // Check if open
        if (self.newTop || self.newTwo || self.newThree) {
          $translate('manage.categories.message_saveOrEdit',{ type: $scope.type }).then(function(data){
            Application.messaging.addMessage({type: '', text: data, duration: 5});
          });

          return;
        }
        // Check language
        if ($scope.language && $scope.language.abr !== 'en' && $scope.language.abr !== 'eng') {
          for (var i = 0; i < self.languages.length; i++) {
            if (self.languages[i].abr === 'en') {
              self.selectLanguage(self.languages[i]);
              break;
            }
          }
          $translate('manage.categories.message_createInEnglish',{ type: $scope.type }).then(function(data){
            Application.messaging.addMessage({type: '', text: data, duration: 5});
          });
        }
        // if parent is null then top level category
        if (category) {
          self.changeIndex(category);
        }

        var newCat = {
          parent: null,
          children: [],
          name: '',
          level: 1,
          localized_names: '',
          category: $scope.type === 'category',
          location: $scope.type === 'location',
          department: $scope.type === 'department',
          team: $scope.type === 'team',
          org_level: $scope.type === 'org_level',
          grade: $scope.type === 'grade'
        };

        if (!self.index) {
          self.newTop = newCat;
        }
        if (self.index === 1) {
          self.newTwo = newCat;
          self.newTwo.parent = self.chosen[0]._id;
          self.newTwo.level = 2;
        }
        if (self.index === 2) {
          self.newThree = newCat;
          self.newThree.parent = self.chosen[1]._id;
          self.newThree.level = 3;
        }
      };

      self.createCategory = function(category) {
        if (self.saving) {
          Application.messaging.addMessage({type: 'error', text: self.translations['categoryEditor.action_in_progress'], duration: 5});
          return;
        }
        var parent;
        var papa;
        if (!category.name) {
          $translate('manage.categories.message_includeNewName',{ type: $scope.type }).then(function(data){
            Application.messaging.addMessage({type: 'error', text: data, duration: 5});
          });
          return;
        }
        if (category && category.parent) {
          parent = category.parent.slice(0);
          if (self.directory[category.parent].parent) {
            papa = self.directory[category.parent].parent.slice(0);
          }
        }
        self.saving = true;

        Categories.create({}, category).$promise
        .then(function(cat) {
          self.saving = false;
          self.cancelNew();
          self.findType = function(type){
            if (type === 'org_level'){
              return 'organization level'
            } else {
              return type;
            };
          };
          $translate('manage.categories.message_wasCreated',{ type: self.findType($scope.type) }).then(function(data){
            Application.messaging.addMessage({type: 'success', text: data, duration: 5});
          });
          self.initialize()
          .then(function(data) {
            if (papa) {
              self.changeIndex(self.directory[papa]);
            }
            if (parent) {
              self.changeIndex(self.directory[parent]);
            }
          });
        });
      };

      self.cancelNew = function() {
        self.newTop = null;
        self.newTwo = null;
        self.newThree = null;
      };

      self.showRemove = function(category) {
        self.deleteCategory = category._id;
        self.deleteChildren = [];
        var additional = [];
        if (category.children && category.children.length) {
          self.deleteChildren = self.deleteChildren.concat(category.children);
        }
        if (self.deleteChildren.length) {
          for (var i = 0; i < self.deleteChildren.length; i++) {
            if (self.directory[self.deleteChildren[i]] && self.directory[self.deleteChildren[i]].children && self.directory[self.deleteChildren[i]].children.length) {
              additional = additional.concat(self.directory[self.deleteChildren[i]].children);
            }
          }
        }
        if (additional.length) {
          self.deleteChildren = self.deleteChildren.concat(additional);
        }
        self.showRemoveModal = true;
      };

      self.cancelRemove = function() {
        self.deleteCategory = '';
        self.deleteChildren = [];
        self.showRemoveModal = false;
      };

      self.removeCategory = function(category) {
        var parent;
        var papa;
        if (self.directory[category] && self.directory[category].parent) {
          parent = self.directory[category].parent.slice(0);
          if (self.directory[parent] && self.directory[parent].parent) {
            papa = self.directory[parent].parent.slice(0);
          }
        }
        self.saving = true;
        Categories.remove({subresource: category}).$promise
        .then(function(data) {
          self.saving = false;
          self.cancelRemove();
          $translate('manage.categories.message_wasDeleted',{ type: $scope.type }).then(function(data){
            Application.messaging.addMessage({type: 'success', text: data, duration: 5});
          });
          self.initialize()
          .then(function(data) {
            var set;
            if (papa) {
              set = true;
              self.changeIndex(self.directory[papa]);
            }
            if (parent && self.directory[parent].children && self.directory[parent].children.length) {
              set = true;
              self.changeIndex(self.directory[parent]);
            }
            if (!set) {
              self.changeIndex();
            }
          });
        });
      };

      self.listSelect = function(category) {
        if (category && category.children && category.children.length) {
          self.changeIndex(category);
        }
      };

      self.changeIndex = function(category) {
        if (self.newTop || self.newTwo || self.newThree) {
          $translate('manage.categories.message_saveOrEditBeforeChanging',{ type: $scope.type }).then(function(data){
            Application.messaging.addMessage({type: '', text: data, duration: 5});
          });
          return;
        }

        if (!category || category.level === 3) {
          self.viewIndex = '0%';
          self.index = 0;
          return;
        }
        // set options for index level
        self.index = category.level;
        self.chosen[category.level - 1] = category;
        self.options[category.level] = category.children;
        self.viewIndex = -100/3 * category.level + '%';

        // scroll top
        document.querySelector('#collection-menu').scrollIntoView(true);
      };

      self.initialize = function() {
        var params = {};
        self.main = {};
        self.chosen = {};
        self.options = {};
        self.topLevel = [];
        self.directory = {};
        self.contextMenu = {};
        self.itemRename = {};
        self.initialMainName;
        params[$scope.type] = true;


        switch ($scope.type) {
          case 'category':
            self.overviewTitle = self.translations['manage.categories.viewer_categoriesHome'];
            break;
          case 'location':
            self.overviewTitle = self.translations['manage.categories.viewer_LocationsHome'];
            break;
          case 'department':
            self.overviewTitle = self.translations['manage.categories.viewer_departmentsHome'];
            break;
          case 'team':
            self.overviewTitle = self.translations['manage.categories.viewer_teamsHome'];
            break;
          case 'org_level':
            self.overviewTitle = self.translations['manage.categories.viewer_org_levelsHome'];
            break;
          case 'grade':
            self.overviewTitle = self.translations['manage.categories.viewer_gradesHome'];
            break;
          default:
            break
        }

        return Categories.find(params).$promise
        .then(function (data) {
          self.categories = data;
          self.sortCategories();
        });

      };

      $scope.$watch('refresh', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal || newVal !== $scope.type) {
          return;
        }
        self.initialize();
        $scope.refresh = null;
      });

      self.refresh = function() {
        self.initialize();
      };

      $translate([
        'manage.categories.deleteWarning',
        'manage.categories.followingSubordinateRemoved',
        'global.actions.delete',
        'global.actions.cancel',
        'manage.categories.viewer_categoriesHome',
        'manage.categories.viewer_LocationsHome',
        'manage.categories.viewer_departmentsHome',
        'manage.categories.viewer_teamsHome',
        'manage.categories.viewer_org_levelsHome',
        'manage.categories.viewer_gradesHome',
        'categoryEditor.action_in_progress'
      ]).then(function(data){
        self.translations = data;
        self.initialize();
      });

    }],
    controllerAs: 'editor'
  };
}]);
